import React from 'react';
import {
    Grid,
    Paper,
    styled,
} from '@mui/material';

import HealthToolbar from '../components/Toolbars/healthToolbar';
import ShipperHealthTable from '../components/Tables/ShipperHealthTable';

const classesPrefix = 'shipperHealth';

const classes = {
    pageRoot: `${classesPrefix}-pageRoot`,
    pageRootItem: `${classesPrefix}-pageRootItem`,
    tableWrapper: `${classesPrefix}-tableWrapper`,
};

const StyledGrid = styled(Grid)(({ theme }) => {
    return {
        [`&.${classes.pageRoot}`]: {
            minHeight: '100%',
        },
        [`& .${classes.pageRootItem}`]: {
            overflow: 'auto',
            margin: theme.spacing(2),
        },
        [`& .${classes.tableWrapper}`]: {
            height: 'calc(100vh - 144px)',
        },
    };
});

const ShipperHealth = (): React.JSX.Element => {
    return (
        <StyledGrid
            container
            className={classes.pageRoot}
            justifyContent='flex-start'
            direction='column'
        >
            <Grid item xs className={classes.pageRootItem}>
                <Paper>
                    <HealthToolbar pageTitle='Shipper Health' />
                    <Grid container>
                        <Grid item xs={12} className={classes.tableWrapper}>
                            <ShipperHealthTable />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </StyledGrid>
    );
};

export default ShipperHealth;
